import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';

import KpiSpotlightQV from './KpiSpotlightQV';
import Header from '../Header';
import PreHeader from '../PreHeader';
import DriversQV from '../DriversQV';

import {
  activeEntitySelector,
  quickViewDataSelector,
  quickViewSettingsSelector,
} from '../../../selectors';
import { ASSET } from '../../../configs/constants';

const {
  company_data,
  kpi_spotlight,
  drivers,
} = ASSET;

const emptyObject = {};

const FinanceQVContent = ({ onClose }) => {
  const data = useSelector(quickViewDataSelector);
  const { cqv } = useSelector(quickViewSettingsSelector);
  const activeEntity = useSelector(activeEntitySelector);

  const companyData = data[company_data] || emptyObject;
  const activeCompanyData = useMemo(() => ({
    ...activeEntity,
    ...companyData,
  }), [companyData, activeEntity]);

  const kpiSpotlightSettings = {
    ...cqv[kpi_spotlight],
    pending: cqv[company_data].pending || cqv[kpi_spotlight].pending,
  };
  const driversSettings = {
    ...cqv[drivers],
    pending: cqv[company_data].pending || cqv[drivers].pending,
  };

  return (
    <>
      <PreHeader
        companyData={activeCompanyData}
        settings={cqv[company_data]}
        onClose={onClose}
      />
      <div className="company-quick-view__scrollable-container">
        <Header
          companyData={activeCompanyData}
          settings={cqv[company_data]}
          showDataStrengthIndicator
          onClose={onClose}
        />
        <div className="company-quick-view__finance-content-wrapper">
          <KpiSpotlightQV
            data={data[kpi_spotlight]}
            company={activeCompanyData}
            settings={kpiSpotlightSettings}
          />
          <DriversQV
            data={data[drivers]}
            settings={driversSettings}
          />
        </div>
      </div>
    </>
  );
};

FinanceQVContent.propTypes = {
  onClose: T.func.isRequired,
};

export default FinanceQVContent;
